// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Er10S","align-center":"styles_align-center__ZtkL9","align-left":"styles_align-left__l0MfB","align-right":"styles_align-right__Jx3RW"};